"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIds = void 0;
var tslib_1 = require("tslib");
var getOr_1 = (0, tslib_1.__importDefault)(require("lodash/fp/getOr"));
exports.defaultIds = {
    userId: 'Default UserId',
    email: 'fake@ntrs.com',
    uniqueIdentifier: 'aa0fdsfcebfdsfds',
};
var getUserIdentifiers = function (user) {
    if (!user) {
        return exports.defaultIds;
    }
    // okta flow
    var email = (0, getOr_1.default)(exports.defaultIds.email, 'email', user);
    var userId = email === exports.defaultIds.email ? exports.defaultIds.userId : email.split('@')[0];
    var uniqueIdentifier = (0, getOr_1.default)(exports.defaultIds.uniqueIdentifier, 'sub', user);
    return { email: email, userId: userId, uniqueIdentifier: uniqueIdentifier };
};
exports.default = getUserIdentifiers;
